import { render, staticRenderFns } from "./Votecard.vue?vue&type=template&id=6d0c1110&scoped=true"
import script from "./Votecard.vue?vue&type=script&lang=js"
export * from "./Votecard.vue?vue&type=script&lang=js"
import style0 from "./Votecard.vue?vue&type=style&index=0&id=6d0c1110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c1110",
  null
  
)

export default component.exports